// extracted by mini-css-extract-plugin
export default {"checkbox":"SettingsDocumentsCard_checkbox__RXOuC","docRow":"SettingsDocumentsCard_docRow__x5KXx","docLabel":"SettingsDocumentsCard_docLabel__2kCLG"};